var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusicLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 10.3794C20 15.9024 15.523 20.3794 10 20.3794C4.477 20.3794 0 15.9024 0 10.3794C0 4.85739 4.477 0.379395 10 0.379395C15.523 0.379395 20 4.85739 20 10.3794Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8771 7.09962L14.2526 6.49263C14.177 6.41943 14.0762 6.37871 13.97 6.3794L12.1306 6.39313V13.2198C11.7832 13.0295 11.3008 12.997 10.8274 13.1687C10.0732 13.4432 9.63417 14.1355 9.84468 14.7148C10.0553 15.2942 10.8381 15.5413 11.5923 15.267C12.2762 15.018 12.6273 14.4315 12.6291 13.8844C12.6291 12.4025 12.6291 7.78283 12.6291 7.78283L14.5982 7.78737C14.9581 7.78807 15.1363 7.35052 14.8771 7.09962Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6805 6.39312V6.37939H6.00011V7.27941H11.6805V6.39312ZM9.42167 14.8687C9.37664 14.7425 9.34963 14.6122 9.34428 14.4789H6V15.3789H9.75635C9.60519 15.2352 9.49171 15.0627 9.42154 14.8687H9.42167ZM10.6744 12.7458C10.9282 12.6535 11.1892 12.6068 11.4484 12.6068C11.5275 12.6068 11.6049 12.6111 11.6805 12.6196V12.4542H6.00011V13.3542H9.76903C10.0031 13.0882 10.3162 12.8765 10.6744 12.7459V12.7458ZM6.00011 11.3291H11.6807V10.4292H6.00011V11.3291ZM6.00011 9.30426H11.6807V8.40436H6.00011V9.30426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicLibrary);
export default __webpack_public_path__ + "static/media/music_library.44c62c6a9b50cc870f84e68733f83d1d.svg";
export { ForwardRef as ReactComponent };